import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import colors from '@optimizely/design-tokens/dist/json/colors.json';
import classNames from 'classnames';
import { memo } from 'react';
import { WebPushIcon, AppPushIcon } from './custom-icons.js';
import * as iconImports from './icon-imports.js';
import { brandIcons } from './icon-types.js';

library.add(iconImports);
const Icon = memo(
  ({
    className,
    color = colors.iconBaseColor,
    icon,
    name,
    size,
    title,
    transform,
    ...props
  }) => {
    let customIcon;
    switch (name) {
      case "ax-app-push":
        customIcon = /* @__PURE__ */ jsx(
          AppPushIcon,
          {
            className,
            color,
            size,
            title
          }
        );
        break;
      case "ax-app-push-thin":
        customIcon = /* @__PURE__ */ jsx(
          AppPushIcon,
          {
            className,
            color,
            size,
            title,
            weight: "thin"
          }
        );
        break;
      case "ax-web-push":
        customIcon = /* @__PURE__ */ jsx(
          WebPushIcon,
          {
            className,
            color,
            size,
            title
          }
        );
        break;
      case "ax-web-push-thin":
        customIcon = /* @__PURE__ */ jsx(
          WebPushIcon,
          {
            className,
            color,
            size,
            title,
            weight: "thin"
          }
        );
        break;
    }
    if (customIcon) {
      return customIcon;
    }
    let strippedName = name;
    let weight = brandIcons.includes(name) ? "fab" : "fal";
    if (name && name.endsWith("-regular")) {
      weight = "far";
      strippedName = name.replace("-regular", "");
    } else if (name && name.endsWith("-solid")) {
      weight = "fas";
      strippedName = name.replace("-solid", "");
    } else if (name && name.endsWith("-thin")) {
      weight = "fat";
      strippedName = name.replace("-thin", "");
    }
    return /* @__PURE__ */ jsx(
      FontAwesomeIcon,
      {
        className: classNames(
          "axiom-icon",
          `axiom-icon--${size}`,
          "fa-fw",
          className
        ),
        color,
        icon: icon ? icon : [weight, strippedName],
        title,
        transform,
        ...props
      }
    );
  }
);
const OutlinedIcon = ({
  className,
  color,
  icon,
  name,
  outlineColor = colors.brandBackgroundPrimaryColor,
  size,
  title,
  transform,
  ...props
}) => {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Icon,
      {
        className: "axiom-icon-outline",
        color: outlineColor,
        icon,
        name,
        size,
        style: { stroke: `${outlineColor}` },
        transform
      }
    ),
    /* @__PURE__ */ jsx(
      Icon,
      {
        className,
        color,
        icon,
        name,
        size,
        title,
        transform,
        ...props
      }
    )
  ] });
};
const LayeredIcons = ({
  children,
  className,
  size,
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: classNames(
        "axiom-layered-icons",
        `axiom-icon--${size}`,
        "fa-layers fa-fw",
        className
      ),
      ...props,
      children
    }
  );
};
Icon.displayName = "Icon";
OutlinedIcon.displayName = "OutlinedIcon";
LayeredIcons.displayName = "LayeredIcons";

export { Icon, LayeredIcons, OutlinedIcon };
